export default __webpack_public_path__ + "media/jonathan.51837793.jpg";